export const notesFlat = ['C', 'Db', 'D', 'Eb', 'E', 'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B'];
export const notesSharp = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
export const fretmarkDots = [3, 5, 7, 9, 15, 17, 19, 21];
export const defaultTuning = [4, 11, 7, 2, 9, 4];
export const baseOctaves = [3, 2, 2, 1, 1, 1];
export const noteSounds = {
  '-9': new Audio('sounds/DS0.mp3'),
  '-10': new Audio('sounds/D0.mp3'),
  '-11': new Audio('sounds/CS0.mp3'),
  '-12': new Audio('sounds/C0.mp3'),

  0: new Audio('sounds/C1.m4a'),
  1: new Audio('sounds/CS1.m4a'),
  2: new Audio('sounds/D1.m4a'),
  3: new Audio('sounds/DS1.m4a'),
  4: new Audio('sounds/E1.m4a'),
  5: new Audio('sounds/F1.m4a'),
  6: new Audio('sounds/FS1.m4a'),
  7: new Audio('sounds/G1.m4a'),
  8: new Audio('sounds/GS1.m4a'),
  9: new Audio('sounds/A1.m4a'),
  10: new Audio('sounds/AS1.m4a'),
  11: new Audio('sounds/B1.m4a'),

  12: new Audio('sounds/C2.mp3'),
  13: new Audio('sounds/CS2.m4a'),
  14: new Audio('sounds/D2.m4a'),
  15: new Audio('sounds/DS2.m4a'),
  16: new Audio('sounds/E2.m4a'),
  17: new Audio('sounds/F2.m4a'),
  18: new Audio('sounds/FS2.m4a'),
  19: new Audio('sounds/G2.m4a'),
  20: new Audio('sounds/GS2.m4a'),
  21: new Audio('sounds/A2.m4a'),
  22: new Audio('sounds/AS2.m4a'),
  23: new Audio('sounds/B2.m4a'),

  24: new Audio('sounds/C3.mp3'),
  25: new Audio('sounds/CS3.mp3'),
  26: new Audio('sounds/D3.mp3'),
  27: new Audio('sounds/DS3.mp3'),
  28: new Audio('sounds/E3.m4a'),
  29: new Audio('sounds/F3.m4a'),
  30: new Audio('sounds/FS3.m4a'),
  31: new Audio('sounds/G3.m4a'),
  32: new Audio('sounds/GS3.m4a'),
  33: new Audio('sounds/A3.m4a'),
  34: new Audio('sounds/AS3.m4a'),
  35: new Audio('sounds/B3.m4a'),

  36: new Audio('sounds/C4.mp3'),
  37: new Audio('sounds/CS4.mp3'),
  38: new Audio('sounds/D4.mp3'),
  39: new Audio('sounds/DS4.m4a'),
  40: new Audio('sounds/E4.m4a'),
  41: new Audio('sounds/F4.m4a'),
  42: new Audio('sounds/FS4.m4a'),
  43: new Audio('sounds/G4.m4a'),
  44: new Audio('sounds/GS4.m4a'),
  45: new Audio('sounds/A4.m4a'),
  46: new Audio('sounds/AS4.m4a'),
  47: new Audio('sounds/B4.m4a'),
};